import instance from '@/services/repository';
import { MachineryFieldType } from '@/modules/machinery/enums';

const resource = '/machineryprofiles';

export default {
    getAll() {
        return instance.get<IMachineryProfileListItem[]>(`${resource}`);
    },
    getSingle(id: string) {
        return instance.get<IMachineryProfile>(`${resource}/${id}`);
    },
    create(name: string) {
        const payload: ICreateMachineryProfileCommand = {
            name,
        };

        return instance.post<IMachineryProfile>(`${resource}`, payload);
    },
    update(payload: IUpdateMachineryProfileCommand) {
        return instance.put<IMachineryProfile>(`${resource}`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
    getFieldTypes() {
        return [
            {value: MachineryFieldType.Text, text: 'Tekst'},
            // {value: 1, text: 'Nummer'},
            {value: MachineryFieldType.Date, text: 'Datum'},
        ];
    },
};
